<template>
  <div>
    <div class="flex flex-row justify-between">
      <div
        v-if="showPageLimitSelection"
        class="w-1/3"
      >
        <div
          class="flex flex-row"
        >
          <p class="self-center mr-3">
            Show
          </p>
          <vs-select
            v-model="pageSize"
            icon="unfold_more"
            color="secondary"
          >
            <vs-select-item
              v-for="(item, index) of pageSizes"
              :key="index"
              :value="item.value"
              :text="item.text"
            />
          </vs-select>
          <p class="self-center ml-3">
            Data
          </p>
        </div>
      </div>
      <div class="flex flex-row">
        <p
          v-if="totalData"
          class="self-center"
        >
          Showing {{ from }} - {{ to }} of {{ totalData }} data
        </p>
        <p
          v-else
          class="self-center"
        >
          Showing 0 of 0 data
        </p>
      </div>
      <div v-if="!showPageLimitSelection">
        <vs-pagination
          v-model="currentPage"
          color="primary"
          prev-icon="arrow_left"
          next-icon="arrow_right"
          :max="7"
          :total="totalPage || 0"
        />
      </div>
    </div>
    <div
      v-if="showPageLimitSelection"
      class="flex flex-row justify-center"
    >
      <div class="pt-2">
        <vs-pagination
          v-model="currentPage"
          color="primary"
          prev-icon="arrow_left"
          next-icon="arrow_right"
          :max="7"
          :total="totalPage || 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {
  props: {
    showPageLimitSelection: {
      type: Boolean,
      default: () => false
    },
    isSecondaryTable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentPage: this.isSecondaryTable ? this.$store.getters['Table/secondaryTableCurrentPage'] : this.$store.getters['Table/currentPage']
    }
  },
  computed: {
    pageSize: {
      get() {
        return this.isSecondaryTable
          ? this.$store.getters['Table/secondaryTablePageSize']
          : this.$store.getters['Table/pageSize'];
      },
      set(val) {
        this.$store.commit(`Table/SET_PAGE_SIZE${this.isSecondaryTable ? '_SECONDARY_TABLE' : ''}`, val);
        this.fetch();
      }
    },
    totalData() {
      return this.isSecondaryTable
        ? this.$store.getters['Table/secondaryTableTotalData']
        : this.$store.getters['Table/totalData'];
    },
    totalPage() { 
      return this.isSecondaryTable
        ? this.$store.getters['Table/secondaryTableTotalPage']
        : this.$store.getters['Table/totalPage'];
    },
    pageSizes() {
      return this.isSecondaryTable 
        ? this.$store.getters['Table/secondaryTablePageSizes']
        : this.$store.getters['Table/pageSizes'];
    },
    from() {
      return (Number(this.pageSize) * Number(this.currentPage)) - (Number(this.pageSize) - 1)
    },
    to() {
      const isLastPage = this.currentPage === this.totalPage
      return isLastPage
        ? Number(this.totalData)
        : (Number(this.pageSize) * Number(this.currentPage))
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(val) {
        this.$store.commit(`Table/SET_CURRENT_PAGE${this.isSecondaryTable ? '_SECONDARY_TABLE' : ''}`, val)
        this.fetch()
      }
    },
    totalPage: {
      immediate: true,
      handler(val) {
        if(val && (!this.currentPage  || (this.currentPage && val < this.currentPage))) {
          this.currentPage = 1
        }
      }
    }
  },
  methods: {
    fetch: debounce(function () {
      this.$emit('fetch')
    }, 500),
    goToRow(rowIndex) {
      if (!rowIndex || rowIndex < 1) return
      const targetPage = Math.ceil(rowIndex / this.pageSize)
      this.currentPage = targetPage
    }
  },
  beforeCreate() {
    this.$store.dispatch('Table/resetConfig')
  }
}
</script>

<style lang="scss" scoped>
/deep/.vs-pagination--buttons {
  @apply bg-white;
  border-radius: 10px !important;
}

/deep/.vs-pagination--ul {
  @apply bg-transparent;
}

/deep/.vs-pagination--li {
  @apply bg-white mx-2;
}
</style>
